<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-12-31 16:08:25
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';
import DifferentFormTable from './form/DifferentFormTable.vue';
import RiskDetail from './form/RiskDetail.vue';
import RiskStatistics from './form/RiskStatistics.vue';
import { fetchRiskStatistics, formatRiskStatistics, refreshRiskData } from './statistics';

export default {
  extends: TablePage,
  components: {
    Form,
    DifferentFormTable,
    RiskDetail,
    RiskStatistics,
  },
  data() {
    return {
      requestType: 'POST',
      toolbarTip: {
        label: '统计时间说明',
        content: '汇总近一年数据',
        helpContent: '按照当前日期倒推1年，取账期1日至今的提现数据进\n行风控分析。例如2026年10月5日查看报表，数据统计\n时间范围为2025年10月1日至今的全部用户提现数据。',
        subContent: '上次刷新时间：刷新中...',
        subContentClass: 'risk-refresh-time',
      },
    };
  },
  mounted() {
    this.beforeSearchComponent = 'RiskStatistics';
    this.otherHeight = 250;
    this.loadRiskStatistics();
    this.getConfigList('main_list');
  },
  methods: {
    loadRiskStatistics() {
      return fetchRiskStatistics(request).then((result) => {
        const formatted = formatRiskStatistics(result);
        this.beforeSearchData = formatted;
        this.toolbarTip.subContent = `上次刷新时间：${formatted.lastRefreshTime}`;
        return result;
      }).catch(() => {
        const formatted = formatRiskStatistics();
        this.beforeSearchData = formatted;
        this.toolbarTip.subContent = `上次刷新时间：${formatted.lastRefreshTime}`;
        return null;
      });
    },
    modalClick({ val, row }) {
      this.modalConfig = {
        ...this.modalConfig,
        showFooter: false,
        footerType: '',
      };
      if (val.code === 'reconciliation') {
        this.formName = 'Form';
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
        };
        this.modalConfig.title = '对账';
        this.openModal();
      }
      if (val.code === 'view_differences') {
        this.formName = 'DifferentFormTable';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看差异项';
        this.openFull();
      }
      if (val.code === 'check_detail') {
        this.formName = 'RiskDetail';
        this.modalConfig = {
          ...this.modalConfig,
          showFooter: true,
          footerType: 'close',
        };
        this.formConfig = {
          ...this.formConfig,
          row,
        };
        this.modalConfig.title = '绑定用户详情';
        this.openFull();
      }
      if (val.code === 'manually_refresh' || val.buttonCode === 'manually_refresh') {
        const api = this.request || request;
        return refreshRiskData(api).then((res) => {
          if (!res || !res.success) return;
          if (this.$message && this.$message.success) {
            this.$message.success(res.message || '手动刷新指令发送成功，数据正在处理....');
          }
          return this.loadRiskStatistics().then(() => this.getList());
        });
      }
    },
  },
};
</script>
